export default {
    routerName: '',
    locked: 'ロック中',
    unLock: 'ロック解除',
    passwordPlaceholder: 'ログインパスワード',
};
